import {v4 as uuid} from 'uuid';

export const launchInstanceIdFieldName = 'swf:launchInstanceId';
export const richTextUploadUrlAttribute = 'data-swf-rich-text-upload-url';
export const richTextUploadUrlTemplateAttribute = 'data-swf-rich-text-upload-url-template';
export const disableUploadsAttribute = 'data-swf-disable-uploads';

const launchInstanceIdToken = '{launchInstanceId}';

const getAttributeValue = (element, attribute) => {
    const value = element?.getAttribute?.(attribute);
    return typeof value === 'string' ? value.trim() : '';
};

const defaultRichTextUploadUrl = location => `${new URL(location.href).pathname}/attachments`;

export const setupWorkflowLaunchAttachmentMetadata = (root = document) => {
    const field = root.querySelector?.(`input[name="${launchInstanceIdFieldName}"]`);
    const urlTemplateElements = [
        ...(root.matches?.(`[${richTextUploadUrlTemplateAttribute}]`) ? [root] : []),
        ...(root.querySelectorAll?.(`[${richTextUploadUrlTemplateAttribute}]`) || []),
    ];

    if (!field || urlTemplateElements.length === 0) {
        return;
    }

    if (!field.value?.trim()) {
        field.value = uuid();
    }

    urlTemplateElements.forEach(element => {
        const template = getAttributeValue(element, richTextUploadUrlTemplateAttribute);
        if (template) {
            element.setAttribute(
                richTextUploadUrlAttribute,
                template.includes(launchInstanceIdToken)
                    ? template.replaceAll(launchInstanceIdToken, field.value.trim())
                    : template);
        }
    });
};

export const resolveRichTextUploadUrl = (richTextTextArea, location = window.location) => {
    if (getAttributeValue(richTextTextArea, disableUploadsAttribute) === 'true' ||
        getAttributeValue(richTextTextArea?.closest?.(`[${disableUploadsAttribute}]`), disableUploadsAttribute) === 'true') {
        return null;
    }
    const explicitUrl =
        getAttributeValue(richTextTextArea, richTextUploadUrlAttribute) ||
        getAttributeValue(richTextTextArea?.closest?.(`[${richTextUploadUrlAttribute}]`), richTextUploadUrlAttribute);

    return explicitUrl || defaultRichTextUploadUrl(location);
};
